import React from 'react';
import TextField from 'material-ui/TextField';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import { translate } from 'react-i18next';
import firebase from '../firebase';
import compose from '../compose';
import user from '../Auth/user';
import devConfig from '../firebase.config';
import productionConfig from '../firebase.config.production';
import * as firebaseSecond from 'firebase';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

class AddUser extends React.Component {
  constructor(props) {
    super(props);
    this.initialState = {
      email: '',
      password: '',
      emailErrorText: '',
      language: 'en'
    };

    this.state = {
      ...this.initialState
    };
  }

  handleEmailChange = (event, email) => {
    this.setState({emailErrorText: '', email});
  }

  validateEmailwithRegex = (email) => {
    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }
  validateEmail = () => {
    const {t} = this.props;
    if(this.state.email) {
      if (!this.validateEmailwithRegex(this.state.email)) {
        this.setState({emailErrorText:t('invalid')});
        return false;
      } else {
        return true;
      }
    } else {
      this.setState({emailErrorText:t('required')});
      return false;
    }
  }
  handleLanguageChange = (event, index, language) => {
    this.setState({language});
  }

  handleClose = () => {
    this.setState(this.initialState);
    this.props.handleClose();
  }

  handleSave = () => {
    const {t, firebase} = this.props;
    if (!this.validateEmail()) return;

    const config = process.env.REACT_APP_SERVER === 'production' ? productionConfig : devConfig;

    var secondaryApp = firebaseSecond.initializeApp(config, 'Secondary');
    var pwd = Math.random().toString(36).slice(2);
    secondaryApp.auth().createUserWithEmailAndPassword(this.state.email, pwd).then((user) => {
      firebase.database().ref('users/' + user.uid).set({
        language: this.state.language,
      });
      firebase.database().ref('users/' + user.uid + '/shopkeepers/' + this.props.shopkeeperId).set(true);
      firebase.database().ref('shopkeepers/' + this.props.shopkeeperId + '/users/' + user.uid).set(true);
      secondaryApp.auth().sendPasswordResetEmail(user.email);
      secondaryApp.auth().signOut();
      secondaryApp.delete();
      this.handleClose();
    }, () => {
      this.setState({emailErrorText: t('inUse')});
      secondaryApp.delete();
    });
  }
  render() {

    const {t} = this.props;
    const actions = [
      <FlatButton
        label={t('cancel')}
        onTouchTap={this.handleClose}
      />,
      <RaisedButton
        label={t('submit')}
        type="submit"
        primary={true}
        onTouchTap={this.handleSave}
      />,
    ];

    return (
      <Dialog
          title={t('shop.addUser')}
          open={this.props.open}
          onRequestClose={this.handleClose}
          actions={actions}
        >
          <TextField hintText={t('email')}
            floatingLabelText={t('email')}
            errorText={this.state.emailErrorText}
            onChange={this.handleEmailChange}
            onBlur={this.validateEmail}
          />
          <br />
          <SelectField
            autoWidth={true}
            floatingLabelText={t('language')}
            value={this.state.language}
            onChange={this.handleLanguageChange}>
            <MenuItem value={'en'} primaryText="English" />
            <MenuItem value={'fi'} primaryText="Suomi" />
          </SelectField>
        </Dialog>
    );
  }
}

const enhance = compose(translate(), firebase, user);

export default enhance(AddUser);



// WEBPACK FOOTER //
// ./src/Admin/AddUser.js